/*
 * NOTE: This is an auto-generated file created by Iconic.
 *
 * You should not need to edit this file directly; if you need to add/remove any
 * icon modules, you can rebuild it by running `yarn icons:make`.
 */
import * as React from 'react'

import VacasaWrapper from '../Wrapper'

const VacasaInfoCircle: React.FunctionComponent = () => {
  return (
    <VacasaWrapper id="infoCircle" viewBox="0 0 24 24">
      <circle cx="12" cy="12" r="12" fill="#CCD6DB"></circle>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 18.6001C8.35494 18.6001 5.40002 15.6452 5.40002 12.0001C5.40002 8.35507 8.35494 5.40015 12 5.40015C15.6451 5.40015 18.6 8.35507 18.6 12.0001C18.6 15.6452 15.6451 18.6001 12 18.6001ZM12 17.4001C14.9824 17.4001 17.4 14.9825 17.4 12.0001C17.4 9.01781 14.9824 6.60015 12 6.60015C9.01769 6.60015 6.60002 9.01781 6.60002 12.0001C6.60002 14.9825 9.01769 17.4001 12 17.4001ZM12.6 14.4001C12.6 14.7315 12.3314 15.0001 12 15.0001C11.6687 15.0001 11.4 14.7315 11.4 14.4001V12.0001C11.4 11.6688 11.6687 11.4001 12 11.4001C12.3314 11.4001 12.6 11.6688 12.6 12.0001V14.4001ZM11.5758 10.6244C11.3414 10.3901 11.3414 10.0102 11.5758 9.77588C11.8101 9.54157 12.19 9.54157 12.4243 9.77588C12.6586 10.0102 12.6586 10.3901 12.4243 10.6244C12.19 10.8587 11.8101 10.8587 11.5758 10.6244Z"
        fill="#003349"
      ></path>
    </VacasaWrapper>
  )
}

export default React.memo(VacasaInfoCircle)
